import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';

import { Input, CloseButton, useT } from '@repo/common';
import LinkList from './LinkList';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/24px/icon_24px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/24px/icon_24px_arrow-top.svg';
import { ReactComponent as LinkIcon } from '@repo/common/assets/icons/20px/icon_20px_links.svg';

const EMPTY = { linkType: '', link: '' };

const LINK_TYPE_LABELS = {
  Link: '링크',
  Portfolio: '포트폴리오',
  'Personal Website': '개인 웹사이트',
  LinkedIn: 'LinkedIn',
  GitHub: 'GitHub',
  Behance: 'Behance',
  Dribbble: 'Dribbble',
  Notion: 'Notion',
  Blog: '블로그',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
  Threads: 'Threads',
  'X (Twitter)': 'X (Twitter)',
  YouTube: 'YouTube',
};

const StyledLinkIcon = ({ $state }) => (
  <LinkIcon
    className={classNames({
      'text-icon-primary': $state === 'active',
      'text-icon-placeholder': $state === 'default',
    })}
  />
);

const MobileLinkFullPage = ({ initialData, onClose, onSave }) => {
  const t = useT();
  const [form, setForm] = useState(() => ({
    ...EMPTY,
    ...(initialData || {}),
  }));
  const [openLinkType, setOpenLinkType] = useState(false);

  const linkTypeRef = useRef(null);

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    if (!openLinkType) return;
    const handleClickOutside = (e) => {
      if (linkTypeRef.current && !linkTypeRef.current.contains(e.target)) {
        setOpenLinkType(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [openLinkType]);

  const setField = (field, value) =>
    setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <div className='fixed inset-0 z-[60] flex flex-col bg-grayscale-gray00'>
      <div className='relative shrink-0 h-[54px] px-4 py-3 flex items-center justify-between border-b border-grayscale-gray02'>
        <CloseButton onClick={onClose} />
        <span className='flex-1 truncate px-2 text-center typo-b16Strong text-text-primary'>
          {t('Link', '링크')}
        </span>
        <div className='size-6' />
      </div>

      <div className='flex-1 overflow-y-auto px-4 pt-[30px] pb-[160px] flex flex-col gap-4'>
        {/* Link type */}
        <div ref={linkTypeRef} className='relative'>
          <div onClick={() => setOpenLinkType((v) => !v)}>
            <Input
              label={t('Link type', '링크 유형')}
              placeholder={t('Select link type', '링크 유형을 선택해 주세요')}
              value={t(form.linkType, LINK_TYPE_LABELS[form.linkType])}
              readOnly
              hideCount
              rightIcon={openLinkType ? <ArrowTopIcon /> : <ArrowBottomIcon />}
            />
          </div>
          {openLinkType && (
            <div className='relative w-full mt-1.5 z-10'>
              <LinkList
                onSelect={(l) => {
                  setField('linkType', l);
                  setOpenLinkType(false);
                }}
              />
            </div>
          )}
        </div>

        {/* URL */}
        <Input
          label='URL'
          placeholder={t('Please enter the link', '링크를 입력해 주세요')}
          value={form.link}
          onChange={(e) => setField('link', e.target.value)}
          leftIcon={
            <StyledLinkIcon $state={form.link ? 'active' : 'default'} />
          }
          hideCount
        />
      </div>

      <div className='shrink-0 p-4 border-t border-grayscale-gray02'>
        <button
          type='button'
          onClick={() => onSave(form)}
          className='w-full h-[52px] rounded-[12px] bg-[#1DC37B] text-[#F9F7F4] text-[16px] font-medium transition-colors active:bg-[#009E4F]'
        >
          {t('Add', '추가')}
        </button>
      </div>
    </div>
  );
};

export default MobileLinkFullPage;
